import { forwardRef } from "react";
import type { HTMLAttributes } from "react";
import "./Spinner.css";

export interface SpinnerProps extends Omit<HTMLAttributes<HTMLSpanElement>, "size"> {
  size?: "sm" | "md" | "lg";
  /** Accessible label, defaults to "Loading". */
  label?: string;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

export const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(function Spinner(
  { size = "md", label = "Loading", className, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      role="status"
      aria-label={label}
      className={cx("go4-spinner", `go4-spinner--${size}`, className)}
      {...rest}
    />
  );
});
